import type { IconProps } from "@phosphor-icons/react";
import * as PhosphorIcons from "@phosphor-icons/react/dist/ssr";

interface PhosphorIconProps extends IconProps {
  name: keyof typeof PhosphorIcons;
}

type PhosphorIconComponent = React.ComponentType<IconProps>;
export type PhosphorIconName = keyof typeof PhosphorIcons;

export default function PhosphorIcon({ name, ...props }: PhosphorIconProps) {
  const IconComponent = PhosphorIcons[name] as
    | PhosphorIconComponent
    | undefined;

  if (!IconComponent) return null;
  return <IconComponent {...props} />;
}
